



















































































































































































































import Component from "vue-class-component";
import MedicalTransmissionBase from "@/components/medicalTransmissionEdit/specification/MedicalTransmissionBase";
import DiseaseSettingDialog from "@/components/medicalTransmissionEdit/DiseaseSettingDialog.vue";
import BasicInfo1 from "@/components/medicalTransmissionEdit/specification/part/basicInfo/BasicInfo1.vue";
import BasicInfo2 from "@/components/medicalTransmissionEdit/specification/part/basicInfo/BasicInfo2.vue";
import BasicInfo3 from "@/components/medicalTransmissionEdit/specification/part/basicInfo/BasicInfo3.vue";
import BasicInfo4 from "@/components/medicalTransmissionEdit/specification/part/basicInfo/BasicInfo4.vue";
import BasicInfo5 from "@/components/medicalTransmissionEdit/specification/part/basicInfo/BasicInfo5.vue";
import BasicInfo6 from "@/components/medicalTransmissionEdit/specification/part/basicInfo/BasicInfo6.vue";
import BasicInfo7 from "@/components/medicalTransmissionEdit/specification/part/basicInfo/BasicInfo7.vue";
import BasicInfo8 from "@/components/medicalTransmissionEdit/specification/part/basicInfo/BasicInfo8.vue";
import BasicInfo9 from "@/components/medicalTransmissionEdit/specification/part/basicInfo/BasicInfo9.vue";
import BasicInfo10 from "@/components/medicalTransmissionEdit/specification/part/basicInfo/BasicInfo10.vue";
import BasicInfo11 from "@/components/medicalTransmissionEdit/specification/part/basicInfo/BasicInfo11.vue";
import BasicInfo12 from "@/components/medicalTransmissionEdit/specification/part/basicInfo/BasicInfo12.vue";
import BasicInfo13 from "@/components/medicalTransmissionEdit/specification/part/basicInfo/BasicInfo13.vue";
import OtherMedical1 from "@/components/medicalTransmissionEdit/specification/part/otherMedical/OtherMedical1.vue";
import OtherMedical2 from "@/components/medicalTransmissionEdit/specification/part/otherMedical/OtherMedical2.vue";
import OtherMedical3v2 from "@/components/medicalTransmissionEdit/specification/part/otherMedical/OtherMedical3v2.vue";
import OtherMedical4 from "@/components/medicalTransmissionEdit/specification/part/otherMedical/OtherMedical4.vue";
import FixTotal from "@/components/medicalTransmissionEdit/specification/part/fixTotal/FixTotal.vue";
import Detail from "@/components/medicalTransmissionEdit/specification/part/detail/Detail.vue";

@Component({
  components: {
    DiseaseSettingDialog,
    BasicInfo1,
    BasicInfo2,
    BasicInfo3,
    BasicInfo4,
    BasicInfo5,
    BasicInfo6,
    BasicInfo7,
    BasicInfo8,
    BasicInfo9,
    BasicInfo10,
    BasicInfo11,
    BasicInfo12,
    BasicInfo13,
    OtherMedical1,
    OtherMedical2,
    OtherMedical3v2,
    OtherMedical4,
    FixTotal,
    Detail
  }
})
export default class MedicalTransmissionRev1 extends MedicalTransmissionBase {}
